import * as React from 'react';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';
import { InputBaseComponentProps } from '@mui/material/InputBase';

type Props = MaskedInputProps & InputBaseComponentProps;

export const DateMaskedInput = React.forwardRef<HTMLElement, Props>((props, ref) => (
	<MaskedInput
		mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]}
		{...props}
		ref={(masked: any) => {
			const inputEl = masked ? masked.inputElement : null;

			if (typeof ref === 'function') {
				ref(inputEl);
			} else if (ref && typeof ref === 'object') {
				ref.current = inputEl;
			}
		}}
	/>
));
